module.exports = __webpack_public_path__ + "static/img/dataserviceIndex_2.e2c0c0fe.svg";